import moment from 'moment';

import { dateTimeService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { getParameterCaseInsensitive } from '@/core/utilities';
import { rangeMethods } from '@/data/getDateRanges';

function _timeRange(dateRangeState, timeZoneId) {
  if (!timeZoneId) {
    timeZoneId = moment.tz.guess();
  }

  if (!dateRangeState.isCustomRange) {
    return getParameterCaseInsensitive(rangeMethods, dateRangeState.quickRangeSelector)(timeZoneId);
  }

  if (dateRangeState.timeRange && dateRangeState.timeRange.length === 2) {
    return [moment(dateRangeState.timeRange[0]), moment(dateRangeState.timeRange[1])];
  }

  return [moment().startOf('day'), moment().endOf('day')];
}


export const translatedTimeZoneId = state => dateTimeService.getTimeZoneMapping(state.dateRange.timeZoneId);

export const timeRange = (state, getters) => {
  return _timeRange(state.dateRange, getters.translatedTimeZoneId);
};